<template>
  <v-snackbar
    v-model="notification.value"
    :timeout="10000"
    :color="notification.type"
    bottom
    right
    class="text-body-2"
  >
    {{ notification.text }}
    <v-btn
      text
      icon
      color="white"
      @click="notification.value = false"
    >
      <v-icon>close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
// Modules
import { mapFields } from 'vuex-map-fields'

export default {
  computed: {
    ...mapFields({
      notification: 'app.notification'
    })
  }
}
</script>
